const returnTheme = () => {
  const buttonColor = process.env.REACT_APP_BUTTON_COLOR;
  const buttonLightColor = process.env.REACT_APP_BUTTON_LIGHT_COLOR;
  const buttonTextColor = process.env.REACT_APP_BUTTON_TEXT_COLOR;
  // let buttonColor = "rgb(255, 124, 21)";
  // let buttonLightColor = "rgba(255, 124, 21, 0.12)";
  // let buttonTextColor = "rgb(255, 255, 255)";
  // switch (process.env.REACT_APP_PRODUCT_NAME) {
  //   case "Cascais":
  //     buttonColor = "rgb(255, 124, 21)";
  //     buttonLightColor = "rgba(255, 124, 21, 0.12)";
  //     buttonTextColor = "rgb(255, 255, 255)";
  //     break;
  // }
  return { buttonColor, buttonLightColor, buttonTextColor };
};

const theme = {
  dark: false,
  colors: {
    primary: "rgb(255, 124, 21)",
    lightPrimary: "rgb(255, 211, 176)",
    whiteText: "rgb(255, 255, 255)",
    blackText: "rgb(0,0,0)",
    black: "rgb(0,0,0)",
    white: "rgb(255,255,255)",
    blue54: "#070a54",
    lightGray: "rgb(241, 241, 241)",
    midGray: "rgb(221, 221, 221)",
    logoGray: "rgb(162, 162, 162)",
    bgFooter: "rgb(240, 242, 245)",
    lightBlue: "rgb(234, 239, 244)",
    buttonColor: returnTheme().buttonColor,
    buttonLightColor: returnTheme().buttonLightColor,
    buttonTextColor: returnTheme().buttonTextColor,
  },
};

export default theme;
